module.exports = __webpack_public_path__ + "static/img/bg_coupon_four_grey_used.5dadbcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_four_grey_used.png
// module id = WaKR
// module chunks = 0